import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full space-x-2 flex justify-end" }

import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue';

import { ClientResource } from '@shared/resources/client';

import { useI18n } from 'vue-i18n';
import { useModalsStore } from '@/stores/modals';
import { useEmitter } from '@/plugins/mitt/mitt';
import { ClientService } from '@/services/client.service';

import PageWrapper from '@components/page-wrapper/PageWrapper.vue';
import Table from '@ui-kit/table/Table.vue';
import { TableComponentParams } from '@ui-kit/table/types';
import { TableServerDataManager } from '@ui-kit/table/table-data-managers/table-server-data-manager';
import Button from '@ui-kit/controls/button/Button.vue';
import ModalConfirmation from '@components/modals/ModalConfirmation.vue';
import ModalEditClient from './modals/ModalEditClient.vue';
import ModalAddClient from './modals/ModalAddClient.vue';
import { getClientName } from '../../../helpers/clients';
import { ClientType } from '@shared/types/client-type';
import ClientBadge from '../../partials/ClientBadge.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageClients',
  setup(__props) {

const modalsStore = useModalsStore();
const emitter = useEmitter();
const clientService = new ClientService();
const { t } = useI18n();

const pendingClient = ref<number|null>(null);

const tableParams = computed<TableComponentParams<ClientResource>>(() => {
  return {
    columns: [
      {
        name: 'full_name',
        data: (row) => getClientName(row),
        title: t('fields.name'),
        responsiveOrder: 1,
      },
      {
        name: 'phone',
        data: 'phone',
        title: t('fields.phone'),
        sortable: true,
      },
      {
        name: 'email',
        data: 'email',
        title: t('fields.email'),
        sortable: true,
      },
      {
        name: 'address',
        data: 'address',
        title: t('fields.address'),
        sortable: true,
      },
      {
        name: 'actions',
        title: '',
        width: 200,
        responsiveOrder: 2,
      },
    ],
  }
});
const tableManager = new TableServerDataManager({
  path: 'clients/grid',
});

function addClient() {
  modalsStore.addModal({
    component: ModalAddClient,
  });
}
async function editClient(id: number) {
  pendingClient.value = id;
  const { data } = await clientService.getById(String(id)).send().finally(() => {
    pendingClient.value = null;
  });
  modalsStore.addModal({
    component: ModalEditClient,
    props: {
      data,
    },
  });
}
function removeClient(client: ClientResource) {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.clients.remove-label'),
      danger: true,
      confirmText: t('common.actions.delete'),
      confirm: () => {
        return clientService.remove(client.id).send().then(() => {
          tableManager.request();
        });
      },
    },
  });
}

function updateTable() {
  tableManager.request();
}
onMounted(() => {
  emitter.on('addClient', updateTable);
  emitter.on('updateClient', updateTable);
});
onBeforeUnmount(() => {
  emitter.off('addClient', updateTable);
  emitter.off('updateClient', updateTable);
});


return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(PageWrapper, {
    title: _ctx.$t('navigation.clients')
  }, {
    default: _withCtx(() => [
      _createVNode(Table, {
        "data-manager": _unref(tableManager),
        params: _unref(tableParams)
      }, {
        "header-right": _withCtx(() => [
          _createVNode(Button, {
            size: "xl",
            "button-type": "outline",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (addClient()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "plus",
                class: "mr-2"
              }),
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create_new')), 1)
            ]),
            _: 1
          })
        ]),
        "cell-full_name": _withCtx(({ value, row }) => [
          _createVNode(ClientBadge, {
            class: "mr-2",
            type: row.type
          }, null, 8, ["type"]),
          _createTextVNode(" " + _toDisplayString(value), 1)
        ]),
        "cell-actions": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, {
              size: "sm",
              onClick: ($event: any) => (editClient(row.id)),
              loading: pendingClient.value === row.id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: "pen",
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('common.actions.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick", "loading"]),
            _createVNode(Button, {
              size: "sm",
              color: "danger",
              onClick: ($event: any) => (removeClient(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, { icon: "trash" })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["data-manager", "params"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})